import { regulatoryFormsData } from "@/data/regulatoryFormsData";
import { createSlug } from "@/utils/createSlug";

/**
 * Computes the initial expanded state from URL hash for regulatory forms.
 * Used to determine which accordion item should be expanded on page load.
 */
export function getInitialExpandedItems(): Set<number> {
  if (typeof window === "undefined") return new Set();

  const hash = window.location.hash.slice(1);
  if (hash) {
    const index = regulatoryFormsData.findIndex(
      (item) => createSlug(item.title) === hash
    );
    if (index !== -1 && regulatoryFormsData[index].type === "multiple") {
      return new Set([index]);
    }
  }
  return new Set();
}
